<template>
  <div class="centered-text">
    <div class="wrap">
      <h2>{{ largeText }}</h2>
      <div
        v-dompurify-html="smallText"
        class="centered-text-content"
      />
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      largeText: {
        type: String,
        required: false,
        default: ''
      },
      smallText: {
        type: String,
        required: false,
        default: ''
      }
    }
  }
</script>

<style lang="scss" scoped rel="stylesheet/scss">
  @import "~assets/styles/common.scss";

  .centered-text {
    padding: 35px 23px 15px 23px;
    text-align: center;

    @include bp-mf-tablet() {
      padding: 46px 26px 46px 26px;
    }

    @include bp-mf-desktop() {
      padding-top: 54px;
      padding-bottom: 28px;
    }

    h2 {
      line-height: 1.1;
      padding: 0;
      font-size: em(27);
      font-weight: 400;
      margin: 0 0 20px 0;

      @include bp-mf-tablet() {
        margin-bottom: 25px;
      }

      @include bp-mf-desktop() {
        margin-bottom: 30px;
        font-size: em(30);
      }
    }

    .centered-text-content {
      color: $grey-light;
      font-size: em(14);
      margin-top: 0;
      line-height: 1.5;
      max-width: 630px;
      display: inline-block;

      ::v-deep p {
        padding: 0 0 10px 0;
        margin: 0;

        @include bp-mf-desktop() {
          font-size: em(16);

          .js-inline-button {
            font-size: rem(15, 16);
          }
        }

        a:not(.js-inline-button) {
          color: $green-base;
          text-decoration: none;
        }
      }
    }
  }
</style>
